import { CredentialDefinitionType } from './credential-definition.model';

export type evidenceType =
  | 'CustomField'
  | 'Skill'
  | 'ActiveCertification'
  | 'EvaluationRating'
  | 'Credential';

export class EvidenceDefinition {
  constructor(
    public id: string,
    public attributeDefinitionId: string,
    public evidenceType: evidenceType,
    public credentialDefinitionId: string,
    public evidenceDefinitionName: string
  ) {}

  static parse(obj: any): EvidenceDefinition {
    return new EvidenceDefinition(
      obj.id,
      obj.attributeDefinitionId,
      obj.evidenceType,
      obj.credentialDefinitionId,
      obj.evidenceDefinitionName
    );
  }

  static EvidenceTypeOptions = (forType: CredentialDefinitionType): EvidenceOption[] =>
    Array.from(evidenceTypeOptionsIterator(forType));
}

function* evidenceTypeOptionsIterator(
  forType: CredentialDefinitionType
): Generator<EvidenceOption> {
  yield buildEvidenceOption('CustomField', forType);
  if (forType === CredentialDefinitionType.Person) {
    yield buildEvidenceOption('Skill', forType);
    yield buildEvidenceOption('ActiveCertification', forType);
    yield buildEvidenceOption('EvaluationRating', forType);
  }
  yield buildEvidenceOption('Credential', forType);
}

const buildEvidenceOption = (
  evidence: evidenceType,
  forType: CredentialDefinitionType = null
): EvidenceOption => ({ value: evidence, label: getTextForEvidence(evidence, forType) });

/** only need forType:CredentialDefinitionType for evidence:'CustomField' */
export const getTextForEvidence = (
  evidence: evidenceType,
  forType: CredentialDefinitionType = null
): string => {
  if (!evidence) return 'No evidence type set';
  if (evidence === 'CustomField') {
    return forType === CredentialDefinitionType.Team ? 'Team Custom Field' : 'Person Custom Field';
  }
  if (evidence === 'Skill') return 'Person Skill';
  if (evidence === 'ActiveCertification') return 'Active Certification';
  if (evidence === 'EvaluationRating') return 'Evaluation Rating';
  return evidence; //'Credential' or anything new
};

export type EvidenceOption = { value: evidenceType; label: string };
